exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-message[data-v-0dd1f8d0] {\n  margin-top: 5px;\n}", ""]);

// exports
